import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 350px;
  height: 100vh;
  overflow: hidden;
  position: absolute;

  right: 0px;
  background-color: #fafafa;
  transition: 0.2s;
  // ${(props) =>
    props.shrink &&
    css`
      //     top:150px;
      //
    `}
`;
export const TitleContainer = styled.div`
  width: 100%;
  height: 30px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;
export const Title = styled.h3`
  margin-top: 24px;
  font-family: var(--hyGothic);
  font-size: 15px;
  margin-left: -20px;
`;
export const RemoveCartbutton = styled.p`
  color: black;
  font-size: 14px;
  cursor: pointer;
  margin-top: 24px;
  margin-left: 20px;
`;
export const CartContainer = styled.div`
  width: 100%;
  height: auto;
  max-height: 700px;
  overflow-y: auto;
  ${(props) =>
    props.shrink &&
    css`
      max-height: 640px;
    `}
`;
export const CartItemContainer = styled.div`
  margin-left: 35px;
  height: auto;
  max-height: 9999px;
`;
export const FamilyBox = styled.div`
  position: relative;
  height: 44px;
  width: 194px;
  border: 1px solid #dcdcdc;
  border-bottom: 1px solid var(--mintColor);
  padding: 12px;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
  background-color: white;
`;
export const FamilyName = styled.p`
  font-family: var(--hyGothic);
  font-size: 15px;
  margin-right: 10px;
`;
export const Arrow = styled.button`
  color: var(--mintColor);
  font-family: var(--hyGothic);
  font-size: 15px;
  width: 17px;
  height: 26px;
  outline: 0;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;
export const RemoveFamily = styled.button`
  color: black;
  font-size: 14px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: 0;
  position: absolute;
  right: 10px;
`;
export const FamilyFont = styled.ul`
  list-style: none;
  width: 194px;
  ${(props) => (props.select ? `height:${props.item * 20}px` : "height:0;")}
  overflow:hidden;
  ${(props) => (props.select ? "border:1px solid var(--mintColor);" : "")}
  background-color:white;
`;
export const FontItem = styled.li`
  position: relative;
  border-bottom: 1px solid #dcdcdc;
  height: 33px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  &:nth-last-child {
    border-bottom: none;
  }
`;
export const FontButton = styled.button`
  border: none;
  background-color: transparent;
  border: none;
  outline: none;
`;
export const SmallXButton = styled.button`
  color: black;
  width: 20px;
  height: 20px;
  outline: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 10px;
`;

export const ExportCart = styled.p`
  margin: 20px auto;
  font-family: var(--hyGothic);
  font-size: 15px;
  text-align: center;
  color: var(--mintColor);
  cursor: pointer;
  position: absolute;
  bottom: 130px;
  right: 160px;
`;

export const CartPosition = styled.div`
  top: 15px;
  right: 300px;
  display: flex;
  position: absolute;
`;
